export default __webpack_public_path__ + "static/media/tvbot.ba4427ff.png";